import React from 'react';
import { useApolloClient } from '@apollo/react-hooks';

import useTranslation from 'hooks/use-translation';
import useUser from 'hooks/use-user';
import useErnie from 'shared/hooks/use-ernie';

import { useModals, ModalNames } from 'components/modals';

import MyAccountPopover from './my-account-popover';

const MyAccountPopoverWrapper = ({ isLoggedIn, anchorEL }) => {
  const { t } = useTranslation();
  const User = useUser();
  const { openModal } = useModals();
  const ernie = useErnie();
  const apolloClient = useApolloClient();

  const handleOptionClick = (value) => {
    openModal(value === 'login' ? ModalNames.login : ModalNames.signUp);
  };

  const handleOnLogout = async () => {
    // Logout is synchronous but we structure this carefully to ensure
    // auth state is cleared before Apollo refetches
    User.logout();

    /**
     * CRITICAL: Reset Apollo cache on logout to refetch queries with anonymous user context.
     *
     * WHY THIS IS NEEDED:
     * - Exclusive collections show different products based on user segments
     * - Server-side cache keys include user segments (logged-in vs logged-out get different results)
     * - Apollo cache must be cleared so queries refetch with new cache keys
     * - Queries using cache-and-network will immediately fetch fresh anonymous results
     *
     * WHAT GETS REFETCHED:
     * - MenuFiltersV2 (categories may hide exclusive-only categories)
     * - FilteredProducts (exclusive products filtered out)
     * - Collections (exclusive collections become inaccessible)
     *
     * Note: User.logout() is synchronous and clears auth immediately, so resetStore()
     * will refetch with anonymous context.
     */
    try {
      await apolloClient.resetStore();
    } catch (error) {
      console.warn('Failed to reset Apollo cache on logout:', error);
    }

    ernie(t('ernie.logout', "You've been successfully logged out."), 'success');
  };

  return (
    <MyAccountPopover
      isLoggedIn={isLoggedIn}
      onOptionClick={handleOptionClick}
      onLogout={handleOnLogout}
      anchorEL={anchorEL}
    />
  );
};

export default MyAccountPopoverWrapper;
